import React, { Component } from "react";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import BasicButton from "../../../components/SharedComponents/BasicButton/BasicButton";
import BasicTextField from "../../../components/SharedComponents/BasicTextField/BasicTextField";
import BasicCheckbox from "../../../components/SharedComponents/BasicCheckbox/BasicCheckbox";
import BasicLabel from "../../../components/SharedComponents/BasicLabel/BasicLabel";
import CircularProgress from "@material-ui/core/CircularProgress";
import BasicTextArea from "../../../components/SharedComponents/BasicTextArea/BasicTextArea";
import SelectField from "../../../components/SharedComponents/SelectField/SelectField";
import SearchSelectField from "../../../components/SharedComponents/SearchSelectField";
import "./ShowSeasonSong.scss";
import TableComponent from "../../../components/SharedComponents/Table";
import clearTrackService from "../../../services/service";
import * as Constants from "../../../constants/constants";
import { withUserContext } from "../../../contexts/UserContext";
import {
  agentListConfig,
  allContactList,
  reportConfig,
  allreportList,
  initialshowSeasonDetails,
} from "../Reports/config";
import Radio from "@material-ui/core/Radio";
import ShowSeason from "./ShowSeason";
import Chip from "@material-ui/core/Chip";

class ShowSeasonSong extends Component {
  constructor() {
    super();
    this.state = {
      postInitiated: false,
      renderList: allContactList,
      config: agentListConfig,
      renderList1: allreportList,
      config1: reportConfig,
      showSeasonDetails: initialshowSeasonDetails,
      seasonOptions: [],
      showOptions: [],
      filterValues: [],
      removedItem: null,
      seasonIdValues: [],
      showIdValues: []
    };
  }


  handleFilterValues = (filterValues) => {
    let values = this.state.filterValues;
    values = filterValues
    this.setState({
      filterValues: values
    })
  }

  setSeasonId = (seasonIdValues) => {
    let seasonIdValue = this.state.seasonIdValues;
    seasonIdValue = seasonIdValues;
    this.setState({
      seasonIdValues: seasonIdValue
    })
  }

  setShowId = (showIdValues) => {
    let showIdValue = this.state.showIdValues;
    showIdValue = showIdValues;
    this.setState({
      showIdValues: showIdValue
    })
  }


  handleFilterDelete = (removeNode, index) => {
    let filterValues = this.state.filterValues;
    let removedItem = filterValues.splice(index, 1);
    this.setState({ filterValues: filterValues, removedItem: removeNode }, () => {
      let splitVal = this.state.removedItem.split(":");
      let name = splitVal[0].trim();
      let valueId = splitVal[1].trim();
      if (name === "Season") {
        let filterSeasonIdValues = this.state.found.find(item => item.label === valueId).value
        let index2 = this.state.seasonIdValues.indexOf(filterSeasonIdValues)
        let id = this.state.seasonIdValues
        id.splice(index2, 1);
        this.setState({seasonIdValues: id})
      }
      else if (name === 'Show') {
        let filterSeasonIdValues = this.state.showOptions.find(item => item.text === valueId).value
        let index2 = this.state.showIdValues.indexOf(filterSeasonIdValues)
        let id = this.state.showIdValues
        id.splice(index2, 1);
        this.setState({showIdValues: id})
      }
    });
  }
  seasonValues = (seasonValue) => {
    this.setState({found:seasonValue})
  }

  showValues = (showValue) => {
    let backup = this.state.showOptions
    backup = backup.concat(showValue)
    this.setState({showOptions:backup})
  }

  handleChange = (field, value) => {
    this.setState((prevState) => ({
        showSeasonDetails: {
          ...prevState.showSeasonDetails,
          [field]: value ? 1 : 0,
        },
    }));
  };

  handleSubmitShowSeasonSongReport = () => {
    this.setState({ postInitiated: true, isPosting: true });
    let { showSeasonDetails, filterValues, seasonIdValues, showIdValues } = this.state;
    let payload = {
      is_include_songs : showSeasonDetails?.is_include_songs ,
      is_display_artist_on_report: showSeasonDetails?.is_display_artist_on_report ,
      is_exclude_main_title: showSeasonDetails?.is_exclude_main_title ,
      is_show_incomplete_episode: showSeasonDetails?.is_show_incomplete_episode,
      is_show_complete_episode: showSeasonDetails?.is_show_complete_episode,
      is_exclude_all_costs: showSeasonDetails?.is_exclude_all_costs,
      is_exclude_costs_breakdown: showSeasonDetails?.is_exclude_costs_breakdown,
      is_show_home_video_cost: showSeasonDetails?.is_show_home_video_cost,
      is_display_criteria_on_report: showSeasonDetails?.is_display_criteria_on_report,
      is_include_pending_songs: showSeasonDetails?.is_include_pending_songs,
      season_ids: seasonIdValues,
      show_ids: showIdValues
    }
    let reportName = "rptShowSeasonEpisodeCost";
    let reportDownloadName = "ShowSeasonEpisodeCost";
    this.props.generateReport(reportName, payload, reportDownloadName).then(webSocketConn => {
      webSocketConn.onmessage = (e) => {
        let response = JSON.parse(e.data)
        if (response?.statusCode == 200) {
          this.setState({ postInitiated: false })
          this.props?.downloadUrl(response?.body);
          // this.props?.notificationComponent(true, 'success')
        } else {
          this.setState({ postInitiated: false })
          // this.props?.notificationComponent(true, 'fail')
        }
      }
    })
  }

  handleClearFilters = () => {
    let values = this.state.filterValues;
    values = [];
    this.setState({ filterValues: values, showSeasonDetails : [],seasonIdValues:[], showIdValues:[] });
  }
 

  GenerateCleranceDetails = () => { };
  render() {
    return (
      <>
        {" "}
        <p>
          <b>Show Season Song/Cost to Date</b>
        </p>
        <MDBRow className={this.state.filterValues?.length > 0 ? "columnFilters d-block" : "d-none"}>
          <div style={{ display: "flex" }}>
            {this.state.filterValues &&
              this.state.filterValues?.map((item, index) => (
                <Chip
                  label={item}
                  onDelete={this.handleFilterDelete.bind(
                    this,
                    item,
                    index
                  )}
                // filterValues={this.state.filterValues}
                />
              ))}
          </div>
        </MDBRow>
        <MDBContainer
          style={{ background: "white" }}
          fluid
          className="ModalContainer"
        >
          <MDBRow>
            <MDBCol md={2}>
              <br />
              <BasicCheckbox
                id="Include Songs"
                label={"Include Songs"}
                checked={this.state.showSeasonDetails?.is_include_songs || false}
                onChange={(e) =>
                  this.handleChange("is_include_songs", e.target.checked)
                }
              />
              <BasicCheckbox
                id="Display Artist on Report"
                label={"Display Artist on Report"}
                checked={this.state.showSeasonDetails?.is_display_artist_on_report || false}
                onChange={(e) =>
                  this.handleChange("is_display_artist_on_report", e.target.checked)
                }
              />
              <BasicCheckbox
                id="Exclude Main Title"
                label={"Exclude Main Title"}
                checked={
                  this.state.showSeasonDetails?.is_exclude_main_title || false
                }
                onChange={(e) =>
                  this.handleChange("is_exclude_main_title", e.target.checked)
                }
              />
              <BasicCheckbox
                id="Show Incomplete Episodes"
                label={"Show Incomplete Episodes"}
                checked={
                  this.state.showSeasonDetails?.is_show_incomplete_episode || false
                }
                onChange={(e) =>
                  this.handleChange("is_show_incomplete_episode", e.target.checked)
                }
              />
              <BasicCheckbox
                id="Show Completed Episodes"
                label={"Show Completed Episodes"}
                checked={
                  this.state.showSeasonDetails?.is_show_complete_episode || false
                }
                onChange={(e) =>
                  this.handleChange("is_show_complete_episode", e.target.checked)
                }
              />
            </MDBCol>
            <MDBCol md={2}>
              {this.state.showSeasonDetails?.is_include_songs ?
              <BasicCheckbox
              id="Include pending Songs"
              label={"Include Pending Songs"}
              checked={this.state.showSeasonDetails?.is_include_pending_songs || false}
              onChange={(e) =>
                this.handleChange("is_include_pending_songs", e.target.checked)
              }/> : <br/>
              }
              <BasicCheckbox
                id="Exclude All Costs"
                label={"Exclude All Costs"}
                checked={ this.state.is_exclude_costs_breakdown === 1 ? false :
                  this.state.is_exclude_all_costs
                }
                onChange={(e) =>
                  this.handleChange("is_exclude_all_costs", e.target.checked)
                }
              />
              <BasicCheckbox
                id="Exclude Cost Breakdown"
                label={"Exclude Cost Breakdown"}
                checked={ this.state.is_exclude_all_costs === 1 ? false :
                  this.state.is_exclude_costs_breakdown
                }
                onChange={(e) =>
                  this.handleChange("is_exclude_costs_breakdown", e.target.checked)
                }
              />
              <BasicCheckbox
                id="Show Home Video Cost"
                label={"Show Home Video Cost"}
                checked={
                  this.state.showSeasonDetails?.is_show_home_video_cost || false
                }
                onChange={(e) =>
                  this.handleChange("is_show_home_video_cost", e.target.checked)
                }
              />
              <BasicCheckbox
                id="Display Criteria on Report"
                label={"Display Criteria on Report"}
                checked={
                  this.state.showSeasonDetails?.is_display_criteria_on_report || false
                }
                onChange={(e) =>
                  this.handleChange("is_display_criteria_on_report", e.target.checked)
                }
              />
            </MDBCol>
            <MDBCol md={7}>
              <ShowSeason
                onChangeCallBack={this.handleFilterValues}
                removedItem={this.state.removedItem}
                // setSeasonId={this.setSeasonId}
                // setShowId={this.setShowId} 
                filterSeasonIdValues={this.state.seasonIdValues}
                filterShowIdValues={this.state.showIdValues}
                filterValues={this.state.filterValues} 
                seasonValues={this.seasonValues}
                showValues={this.showValues}/>
            </MDBCol>
            {/* <MDBCol md={3}>
              <BasicLabel text="Seasons" />
              <SearchSelectField
                placeHolderText={"All Seasons"}
                value={{ 'value': this.state.showSeasonDetails.selected_all_season?.value, 'text': this.state.showSeasonDetails.selected_all_season?.text } || {}}
                // value={this.state.showSeasonDetails.selected_all_season}
                options={this.state.seasonOptions || []}
                onChange={(e, value) => this.handleChange("selected_all_season", value)}
              />
            </MDBCol>
            <MDBCol md={3}>
              <BasicLabel text="Shows" />
              <SearchSelectField
                id={"All Shows"}
                placeHolderText={"All Shows in selected season(s)"}
                value={{ 'value': this.state.showSeasonDetails.selected_shows?.value, 'text': this.state.showSeasonDetails.selected_show?.text } || {}}
                options={this.state.showOptions || []}
                onChange={(e, value) => this.handleChange("selected_shows", value)}
              />
            </MDBCol> */}
          </MDBRow>
        </MDBContainer>
        <MDBRow>
          <MDBCol md={9}></MDBCol>
          <MDBCol md={3}>
            <MDBRow>
              <MDBCol id="genpdf-btn">
                <br />
                <BasicButton className="efcBtn" text={this.state.postInitiated ? (
                    <CircularProgress color="inherit" size={18} />
                  ) : "Generate PDF"} onClick={this.handleSubmitShowSeasonSongReport} />
              </MDBCol>
              <MDBCol>
                <br />
                <BasicButton variant="outlined" text={"Clear Filters"} onClick={this.handleClearFilters}/>
              </MDBCol>
            </MDBRow>
          </MDBCol>
        </MDBRow>
      </>
    );
  }
}

export default withUserContext(ShowSeasonSong);
